import { ErrorMessage } from '@sdir/utilities/lib/components';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import Certificate, {
  CertificateProps,
} from '@sdir/blueprint.aps/lib/components/Organisms/Certificate';
import { formatFullName } from '@sdir/blueprint.aps/lib/helpers/formattingHelpers';
// eslint-disable-next-line max-len
import { PersonalCertificateVerificationResultV3 } from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import { CapitalizeString } from '../../../helpers/certificateHelpers';
import { personalCertificateVerifyApi } from '../../../httpclient';

const CertificatePage: React.FC = () => {
  const { uid } = useParams<{ uid: string }>();
  const [searchError, setSearchError] = useState(null);
  const [certificate, setCertificate] = useState<null | PersonalCertificateVerificationResultV3>(
    null
  );

  useEffect(() => {
    personalCertificateVerifyApi
      .v3PersonalcertificateverifyVerifybyqrcodestringorguidv3IdentificatorGet(uid)
      .then((response) => {
        if (response.status === 200) {
          setCertificate(response.data);
        }
      })
      .catch((error) => {
        setSearchError(error);
        setCertificate(null);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const certificateProps: CertificateProps = useMemo(() => {
    const seafarerName = formatFullName(
      certificate?.seafarerFirstName || '',
      certificate?.seafarerMiddleName || '',
      certificate?.seafarerLastName || ''
    );
    const positionList =
      certificate?.limitations?.map((l) => {
        return {
          position: l.capacity || '',
          limitations: l.limit ? [CapitalizeString(l.limit)] : [],
        };
      }) || [];
    return {
      certificateName: certificate?.certificateName || '',
      authorizedOfficial: certificate?.authorizedOfficial || '',
      issuingAuthority: certificate?.issuingAuthority,
      dateOfBirth: certificate?.dateOfBirth || '',
      name: seafarerName,
      minimumRequirements: certificate?.minimumRequirements || '',
      accessibilityStatement: certificate?.accessibilityRequirement || '',
      limitationStatement: certificate?.capacityLimitationStatement || '',
      meetsRequirementStatement: certificate?.meetsRequirementUntil || '',
      positionList: positionList || [],
      qrData: '',
      qrImageLoading: false,
      certificateNr: certificate?.certificateNumber || '',
      hideLanguageSelector: true,
      hideQr: true,
      issuedDate: certificate?.issuedAt,
      validFrom: certificate?.validFrom || '',
    };
  }, [certificate]);

  return (
    <Wrapper>
      {certificate && (
        <CertificateWrapper translate="no">
          <Certificate {...certificateProps} />
        </CertificateWrapper>
      )}
      {searchError && <ErrorMessage error={searchError} />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 2em;
`;

const CertificateWrapper = styled.div`
  margin: 20px 0;
  p {
    margin: 0;
  }
`;

export default CertificatePage;
